<!------------------------------------------------------------------------------
  Copyright (c) 2019. Keni Williams <kenneth.williams@estuk.co.uk>

  This file CheckoutVoucherCode.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  CheckoutVoucherCode.vue can not be copied and/or distributed
  without the express permission of Keni Williams <kenneth.williams@estuk.co.uk>
  ----------------------------------------------------------------------------->

<template>
    <div class="container px-0">
        <div class="row">
            <!--        the voucher input-->
            <div v-show="show_voucher_input"
                 class="col-12 col-md-5 offset-md-2"
            >
                <input
                        ref="voucher_code_ref"
                        type="text"
                        name="voucher_code"
                        id="voucher-code"
                        class="w-100 voucher-code plate my-0 mx-md-2"
                        v-on:keypress="typing"
                        :class="{
                            'voucher-code--invalid':has_error
                        }"
                        v-model="voucherCode"
                >
            </div>
            <!--        validate voucher btn-->
            <div v-if="not_blank && !voucher_applied"
                 class="col-6 col-md-2 text-right">
                <div
                        class="m-md-0 btn btn-small btn-secondary voucher-code--validate"
                        v-on:click="click">
                    <template>
                        validate
                    </template>
                </div>
            </div>
            <!--            show dummy button-->
            <div v-else
                 class="col-6 col-md-2 text-right"
                 :class="{
                    'offset-md-7':!show_voucher_input
                }"
            >
                <div class="m-md-0 btn btn-small btn-outline-info disabled voucher-code--validate">
                    <template v-if="voucher_response===null">
                        validate
                    </template>
                    <template v-if="voucher_response === true">
                        valid
                    </template>
                </div>
            </div>
            <!--        show-hide voucher toggle-->
            <div class="col-6 text-left text-md-right col-md-3"
            >
                <div v-on:click="show_voucher_input=!show_voucher_input"
                     class="m-md-0 btn-small voucher-code--btn"
                     style="padding:.85rem 2.13rem; line-height: 2rem; text-align:center; box-shadow: 0 2px 5px 0 #eee, 0 2px 10px 0 #ddd; text-transform: uppercase; cursor:pointer;"
                >
                    <template v-if="!show_voucher_input">Discount<span class="d-none d-md-inline"> code</span></template>
                    <template v-else>Cancel</template>
                </div>
            </div>

        </div>
        <div class="row">
            <div class="col-12 text-right py-2">
                <transition name="fade">
                    <!--                <small v-if="voucher_code_status === null || voucher_code_status === 200">All good :)</small>-->
                    <!--                filtered and not applicable-->
                    <small v-if="voucher_code_status === 100">Voucher code not valid</small>
                    <!--                processed-->
                    <small v-else-if="voucher_code_status === 200">Voucher code applied to eligible tickets</small>
                    <!--                inactive-->
                    <small v-else-if="voucher_code_status === 401">Voucher code no longer valid</small>
                    <!--                not found-->
                    <small v-else-if="voucher_code_status === 404">Voucher code not valid</small>
                    <!--                used up-->
                    <small v-else-if="voucher_code_status === 406">Voucher code sold out</small>
                    <!--                expired-->
                    <small v-else-if="voucher_code_status === 496">Voucher code expired</small>
                </transition>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "CheckoutVoucherCode",
        props: {
            voucher_code_status: {
                type: Number,
                default: null
            },
            voucher_response: {
                type: Boolean,
                default: null
            },
            not_valid: {
                type: Boolean,
                default: null
            }
        },
        data() {
            return {

                voucherCode: '',
                not_blank: false,
                show_voucher_input: false,
                not_voucher_error: true,
                voucher_applied: false
            }
        },
        mounted() {
            let self = this;

            self.$nextTick(function () {
                self.$refs.voucher_code_ref.setAttribute('autocomplete', 'off');

            })
        },
        methods: {
            click() {
                let validate = this.voucherCode.trim();
                if (validate.length <= 0) {
                    return;
                }
                this.$emit('validate_voucher_code', validate);
            },
            typing() {
                this.not_voucher_error = true;
                this.$emit('update_response_after_error');
            },
        },
        watch: {
            voucher_response(input) {
                this.not_voucher_error = this.voucher_applied = input;
            },
            /**
             *
             * */
            voucherCode(val) {
                if (val === null) {
                    return;
                }
                this.not_blank = val.trim().length > 0;
            },
            /**
             * clear the v-model if disengaged
             * @param active
             */
            show_voucher_input(active) {
                let self = this;


                if (!active) {
                    self.voucherCode = null;
                    self.not_blank = false;
                    self.not_voucher_error = true;
                    self.voucher_applied = false;
                    self.$emit('null_voucher_response');
                }else{
                    self.$nextTick(()=>{
                        self.$refs.voucher_code_ref.focus();
                    })
                }
            }
        },
        computed: {
            has_error() {
                return this.not_voucher_error !== true && this.not_voucher_error !== null
            }
        },
    }
</script>

<style scoped>

    .voucher-code {
        height: 30px;
    }

    .voucher-code--btn,
    .voucher-code--validate {
        padding-top: 6px;
        padding-bottom: 6px;
        line-height: 2rem;
    }

    .voucher-code--invalid {
        background: red;
    }

    /* Enter and leave animations can use different */
    /* durations and timing functions.              */
    .slide-fade-enter-active {
        transition: all .3s ease;
    }

    .slide-fade-leave-active {
        transition: all .1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */
    {
        transform: translateX(10px);
        width: 0;
        opacity: 0;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/checkout/CheckoutVoucherCode.vue